import { render, staticRenderFns } from "./ProductsAndAreaInput.vue?vue&type=template&id=056a7b2b&"
import script from "./ProductsAndAreaInput.vue?vue&type=script&lang=js&"
export * from "./ProductsAndAreaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/form/ProductsAndAreaInput.vue
// module id = null
// module chunks = 